$('body').on('click', '.js-api-example', function(e){
	
	e.preventDefault();
	
	$('.api-item__right-sidebar__result--result').parent().hide();
	
	let method = $(this).parent().parent().attr('data');
	let action = $(this).text();
	
	$.ajax({
		url: '/api/'+method,
		type: "GET",
		data: action.split('?').pop(),
		dataType: 'json',
		processData: false,
		contentType: false,
		success: function (data) {
			if(data.status == 'false' && data.message == 'Ошибка авторизации'){
				window.location.reload();
			}else{
				$('.api-item__right-sidebar__result--result').html(ApiParseJSON(data)).parent().show();
			}
		},
		error: function () {
			$('.api-item__right-sidebar__result--result').text('Ошибка сервера').parent().show();
		},
	});
	
	return false;
	
});

function ApiParseJSON(data,tabs = 0) {
	
	let str = '';
	
	for (var key in data) {
		
		str += ApiAddTabs(tabs);
		
		str += key + ' => ';
		
		if(typeof data[key] === "object") {
			
			let childs = ApiParseJSON(data[key],(tabs+1));
			
			str += '[';
			
			if(childs.length > 0) {
				str += '<br>' + childs + ApiAddTabs(tabs);
			}
			
			str += '],<br>';
			
		}else{
			str += data[key] + ',<br>';
		}
		
	}
	
	return str;
	
}

function ApiAddTabs(tabs = 1){
	
	let str = '';
	
	for(let i=1;i<=tabs;i++){
		str += '&nbsp;&nbsp;';
	}
	
	return str;
	
}
